/** external */
import _ from "lodash";

/** internal */
import {
  getFormattedQuestion,
  isVisualWorksheetElement,
} from "Worksheet/modules/WorksheetUtils";

/**
 * @returns - section-wise question data formatted based on the questions' type and the worksheet mode
 */
export const getFormattedSectionFeedDetailsV2 = ({
  sections,
  mode,
  submissions = [],
  isEvaluationApplicable,
  isSharedWithStudent,
  isStudentEvaluationEnabled,
  isTeacherEvaluationEnabled,
  isStudentSubmissionEnabled,
  isEvaluated,
  isSubmitted,
  isWorksheetEvaluated,
  t,
  showAssessmentToolsInQuestions = false,
}) => {
  const sectionData = {};
  let questionIndex = 1;

  _.forEach(sections, section => {
    const sectionId = _.get(section, "item.id");
    let sectionScore = 0;
    let sectionMarks = 0; // for Evaluated student (achieved score)
    const sectionQuestions = _.get(section, "children", []);

    const formattedQuestions = _.map(sectionQuestions, question => {
      const questionData = _.get(question, "item", {});
      const questionTypeUid = _.get(questionData, "questionType.uid");

      const subQuestions = _.get(question, "children", []);
      const formattedQuestion = getFormattedQuestion({
        question,
        submissions,
        mode,
        isEvaluationApplicable,
        isSharedWithStudent,
        isStudentEvaluationEnabled,
        isTeacherEvaluationEnabled,
        isStudentSubmissionEnabled,
        isEvaluated,
        isSubmitted,
        isWorksheetEvaluated,
        questionIndex,
        subQuestions,
        t,
        showAssessmentToolsInQuestions,
      });

      if (!isVisualWorksheetElement(questionTypeUid)) questionIndex++;
      sectionScore += _.toNumber(
        _.get(formattedQuestion, ["headerConfig", "score"], 0)
      );

      sectionMarks += _.toNumber(
        _.get(formattedQuestion, ["headerConfig", "evaluatedScore"], 0)
      );

      sectionMarks = parseFloat(sectionMarks.toFixed(2));

      return formattedQuestion;
    });

    sectionData[sectionId] = {
      questions: formattedQuestions,
      score: _.round(sectionScore, 2),
      marks: sectionMarks,
    };
  });

  return sectionData;
};
